import React from 'react';
import Todo from './Components/todoreact/Todo';

function App() {
  return (
    <div >
      <Todo />
    </div>
  );
}

export default App;
